// NEW_FILE_JUSTIFIED: Predefined provider data for auto-fill — no existing constant covers this domain
import type { IPredefinedProviderGroup } from '@/@types/insurance';

export const PREDEFINED_PROVIDERS: IPredefinedProviderGroup[] = [
  {
    country: 'Cyprus',
    providers: [
      { name: 'AIG', website: 'https://www.aig.com.cy' },
      { name: 'Eurosure', website: 'https://www.eurosure.com' },
      { name: 'Cosmos Insurance', website: 'https://www.cosmosinsurance.com.cy' },
      { name: 'AKD Insurance', website: 'https://www.akdinsurance.eu' },
      { name: 'Trust Insurance', website: 'https://www.trustcyprusinsurance.com' },
      { name: 'SoEasy', website: 'https://soeasyinsurance.com.cy' },
    ],
  },
];

/**
 * Get predefined providers for a given country.
 * Returns empty array if no predefined providers exist for the country.
 */
export function getPredefinedProviders(country: string): IPredefinedProviderGroup['providers'] {
  const group = PREDEFINED_PROVIDERS.find(g => g.country.toLowerCase() === country.toLowerCase());
  return group?.providers ?? [];
}
